<div class="header">
    <div class="logo logo-dark">
        <a href="" routerLink="/dashboard/home">
            <img src="assets/images/logo/logo-fold.png" alt="Logo">
            <img class="logo-fold" src="assets/images/logo/logo.png" alt="Logo">
        </a>
    </div>
    <div class="nav-wrap">
        <ul class="nav-left">
            <li class="mobile-toggle">
                <a (click)="toggleExpand()">
                    <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" theme="outline"></i>
                </a>
            </li>
        </ul>
        <ul class="nav-right">
            <li class="m-view">
                {{ greeting }}, <strong>{{currentUser.name | titlecase}}</strong>
            </li>
            <li>
                <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'"
                    [nzPlacement]="'bottomRight'">
                    <!-- <nz-avatar [nzIcon]="'user'" nzSrc="assets/images/avatars/User-Profile-PNG.png"></nz-avatar> -->
                    <nz-avatar [nzText]="(currentUser?.name?.split(' ')[0]?.charAt(0) + 
             (currentUser?.name?.split(' ').length > 1 ? currentUser?.name?.split(' ').pop()?.charAt(0) : '')) | uppercase"
                        style="color:#f56a00; background-color:#fde3cf;font-weight: 600;">
                    </nz-avatar>
                </span>
                <nz-dropdown-menu #profile="nzDropdownMenu">
                    <ul nz-menu class="p-b-15 p-t-20">
                        <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                            <div class="d-flex m-r-50">
                                <!-- <nz-avatar nzSize="large"
                                    nzSrc="assets/images/avatars/User-Profile-PNG.png"></nz-avatar> -->
                                <div class="m-l-10">
                                    <p class="m-b-0 text-dark font-weight-semibold">{{currentUser.email}}</p>
                                    <p class="m-b-0 opacity-07">{{currentUser.roleName}}</p>
                                </div>
                            </div>
                        </li>
                        <!-- <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between"
                                routerLink="/authentication/change-password">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="logout" theme="outline"></i>
                                    <span class="m-l-10">Change Password</span>
                                </div>
                                
                            </a>
                        </li> -->
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between"
                                (click)="service.logout()" routerLink="/authentication/login">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="logout" theme="outline"></i>
                                    <span class="m-l-10">Logout</span>
                                </div>
                                <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
                            </a>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </li>
        </ul>
    </div>
</div>